// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__cardMarginBot___fezMo {
}

.styles__formItem___jtjV7 {
}

.styles__formItemHalf___p6Z0z {
}

.styles__formItemMono___HEcTW {
}

.styles__formItemQuarter___KjB1U {
}

.styles__ticketDirections___lSEre {
}

.styles__sectionSmall___yj9QZ {
}

.styles__grantorRelationship___mxmKZ {
  margin-bottom: 20px;
}

.styles__button___fogj1 {
}

.styles__buttonSecondary___CS7kW {
}

.styles__buttonLocal___W9tKV {
  margin-right: 20px;
}

.styles__search___F3y_5 {
}

.styles__searchWrap___vSp9C {
}

.styles__clear___cE3S_ {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: white;
}

.styles__editContact___iI1jJ {
  margin-right: 20px;
  text-transform: capitalize;
}

.styles__contactButtons___YSfbQ {
  margin-bottom: 20px;
}

.styles__contactButtons___YSfbQ:last-child {
    margin-bottom: 0;
  }

.styles__contactButtons___YSfbQ label {
    display: none;
  }

.styles__sectionTitle___IsPjO {
  padding: 16px 20px;
}

.styles__title___Tr22m {
}

.styles__section___XHDl5 {
  margin-bottom: 20px;
}

.styles__sectionNoMargin___q6rH5 {
}

.styles__removeButton___UFROr {
}

.styles__selectButton___dviSx {
}

.styles__marginBottom___qqkOO {
  margin-bottom: 20px;
}

.styles__marginBottom___qqkOO .styles__anchorLink___IPQ6U {
    top: -70px;
  }

.styles__anchorLink___IPQ6U {
  opacity: 0;
  position: relative;
  top: -90px;
  visibility: hidden;
}

.styles__errorSection___fawEj .styles__formSectionLabel___YH5bL {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 10px;
}

.styles__phoneSectionError___ZWfAL {
  border-left: 4px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 20px;
  padding-left: 10px;
}

.styles__emailHeaderRow___yHvh2 {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.styles__emailHeader___dfjL6 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-weight: 400;
  font-size: 12px;
}

.styles__emailRow___cila0 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.styles__emailInputWrapper___LXcEk {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.styles__input___MAPuf {
  width: 100% !important;
}

.styles__emailInputError___vhv5x {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__emailInlineError___LCUtm {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-size: 12px;
  margin-top: 4px;
}

.styles__emailActions___xziH2 {
  align-items: flex-start;
  display: flex;
  gap: 8px;
  height: 42px;
  min-width: 190px;
}

.styles__emailActionButton___ZvdQh {
  align-items: center;
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border-radius: 3px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  height: 42px;
  justify-content: center;
  min-width: 52px;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__addEmailButton____JbzO {
  margin-top: 4px;
}

.styles__logInfoOffset___aHu45 {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./universal/components/Forms/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8DAAuB;EACvB,YAAY;AAEd;;AAEA;EAEE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AASrB;;AAPE;IACE,gBAAgB;EAClB;;AAEA;IACE,aAAa;EACf;;AAGF;EAEE,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mDAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mEAA4B;EAC5B,mDAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mDAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;AACd;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,0DAAmB;AACrB;;AAEA;EACE,mDAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8DAA6B;EAC7B,kBAAkB;EAClB,mDAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtRed, gtBlueDark, gtBlueLight, textLight, gtGrayDark from colors;\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.formItem {\n  composes: formItem clearfix from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf clearfix from helpers;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.formItemQuarter {\n  composes: formItemQuarter clearfix from helpers;\n}\n\n.ticketDirections {\n  composes: ticketDirections clearfix from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.grantorRelationship {\n  composes: clearfix from helpers;\n  margin-bottom: 20px;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n  margin-right: 20px;\n}\n\n.search {\n  composes: search from helpers;\n}\n\n.searchWrap {\n  composes: searchWrap from helpers;\n}\n\n.clear {\n  background-color: gtRed;\n  color: white;\n  composes: button from helpers;\n}\n\n.editContact {\n  composes: buttonSecondary;\n  margin-right: 20px;\n  text-transform: capitalize;\n}\n\n.contactButtons {\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  label {\n    display: none;\n  }\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n  padding: 16px 20px;\n}\n\n.title {\n  composes: title from helpers;\n}\n\n.section {\n  composes: section from helpers;\n  margin-bottom: 20px;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.removeButton {\n  composes: removeButton from helpers;\n}\n\n.selectButton {\n  composes: buttonSecondary from helpers;\n}\n\n.marginBottom {\n  margin-bottom: 20px;\n\n  .anchorLink {\n    top: -70px;\n  }\n}\n\n.anchorLink {\n  opacity: 0;\n  position: relative;\n  top: -90px;\n  visibility: hidden;\n}\n\n.errorSection .formSectionLabel {\n  color: gtRed;\n  margin-bottom: 10px;\n}\n\n.phoneSectionError {\n  border-left: 4px solid gtRed;\n  color: gtRed;\n  margin-bottom: 20px;\n  padding-left: 10px;\n}\n\n.emailHeaderRow {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.emailHeader {\n  color: textLight;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.emailRow {\n  align-items: flex-start;\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.emailInputWrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.input {\n  composes: input from helpers;\n  width: 100% !important;\n}\n\n.emailInputError {\n  border-color: gtRed;\n}\n\n.emailInlineError {\n  color: gtRed;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.emailActions {\n  align-items: flex-start;\n  display: flex;\n  gap: 8px;\n  height: 42px;\n  min-width: 190px;\n}\n\n.emailActionButton {\n  align-items: center;\n  background: white;\n  border: 1px solid gtBlueLight;\n  border-radius: 3px;\n  color: gtGrayDark;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 12px;\n  height: 42px;\n  justify-content: center;\n  min-width: 52px;\n  text-decoration: none;\n}\n\n.addEmailButton {\n  composes: buttonSecondary from helpers;\n  margin-top: 4px;\n}\n\n.logInfoOffset {\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"cardMarginBot": `styles__cardMarginBot___fezMo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"formItem": `styles__formItem___jtjV7 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"formItemHalf": `styles__formItemHalf___p6Z0z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"formItemMono": `styles__formItemMono___HEcTW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"formItemQuarter": `styles__formItemQuarter___KjB1U ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemQuarter"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"ticketDirections": `styles__ticketDirections___lSEre ${___CSS_LOADER_ICSS_IMPORT_1___.locals["ticketDirections"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"sectionSmall": `styles__sectionSmall___yj9QZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"grantorRelationship": `styles__grantorRelationship___mxmKZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"button": `styles__button___fogj1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonSecondary": `styles__buttonSecondary___CS7kW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"buttonLocal": `styles__buttonLocal___W9tKV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"search": `styles__search___F3y_5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["search"]}`,
	"searchWrap": `styles__searchWrap___vSp9C ${___CSS_LOADER_ICSS_IMPORT_1___.locals["searchWrap"]}`,
	"clear": `styles__clear___cE3S_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"editContact": `styles__editContact___iI1jJ styles__buttonSecondary___CS7kW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"contactButtons": `styles__contactButtons___YSfbQ`,
	"sectionTitle": `styles__sectionTitle___IsPjO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"title": `styles__title___Tr22m ${___CSS_LOADER_ICSS_IMPORT_1___.locals["title"]}`,
	"section": `styles__section___XHDl5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___q6rH5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"removeButton": `styles__removeButton___UFROr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["removeButton"]}`,
	"selectButton": `styles__selectButton___dviSx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"marginBottom": `styles__marginBottom___qqkOO`,
	"anchorLink": `styles__anchorLink___IPQ6U`,
	"errorSection": `styles__errorSection___fawEj`,
	"formSectionLabel": `styles__formSectionLabel___YH5bL`,
	"phoneSectionError": `styles__phoneSectionError___ZWfAL`,
	"emailHeaderRow": `styles__emailHeaderRow___yHvh2`,
	"emailHeader": `styles__emailHeader___dfjL6`,
	"emailRow": `styles__emailRow___cila0`,
	"emailInputWrapper": `styles__emailInputWrapper___LXcEk`,
	"input": `styles__input___MAPuf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"emailInputError": `styles__emailInputError___vhv5x`,
	"emailInlineError": `styles__emailInlineError___LCUtm`,
	"emailActions": `styles__emailActions___xziH2`,
	"emailActionButton": `styles__emailActionButton___ZvdQh`,
	"addEmailButton": `styles__addEmailButton____JbzO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"logInfoOffset": `styles__logInfoOffset___aHu45`
};
export default ___CSS_LOADER_EXPORT___;
